import { useMemo } from "react";
import { useAppSelector } from "../../hooks/StoreHooks";

export const useServiceModules = () =>
  useAppSelector((state) => state.serviceModules.serviceModules);

export const useServiceModuleIdNamePairs = () =>
  useAppSelector((state) =>
    state.serviceModules.serviceModules.map(({ id, name }) => ({ id, name }))
  );

export const useNewestServiceModule = () =>
  useAppSelector((state) => state.serviceModules.newestServiceModule);

export const useRootServiceModules = () =>
  useAppSelector((state) =>
    state.serviceModules.serviceModules.filter(
      (module) => module.parentFolderServiceModuleId === null
    )
  );

export const useOnServiceModulesSave = () =>
  useAppSelector((state) => state.serviceModules.onSave);

export const useServiceModuleById = (id: number) =>
  useAppSelector((state) =>
    state.serviceModules.serviceModules.find((instance) => instance.id === id)
  );

export const useServiceModulesWithId = (id: number) =>
  useAppSelector((state) =>
    state.serviceModules.serviceModules.filter((instance) => instance.id === id)
  );

export const useCalendarEvents = () =>
  useAppSelector((state) => state.serviceModules.calendarEvents);

export const useCalendarEventById = (id: number) =>
  useAppSelector((state) =>
    state.serviceModules.calendarEvents.find((event) => event.id === id)
  );

export const useFolderModuleById = (serviceModuleId: string) =>
  useAppSelector((state) => state.serviceModules.folderModules[serviceModuleId]);

export const useFileModuleById = (serviceModuleId: string) =>
  useAppSelector((state) => state.serviceModules.fileModules[serviceModuleId]);

export const useTextModuleById = (serviceModuleId: string) =>
  useAppSelector((state) => state.serviceModules.textModules[serviceModuleId]);

export const useUrlModuleById = (serviceModuleId: string) =>
  useAppSelector((state) => state.serviceModules.urlModules[serviceModuleId]);

export const useLeaderboardModuleById = (serviceModuleId: string) =>
  useAppSelector((state) => state.serviceModules.leaderboardModules[serviceModuleId]);

export const useLeaderboardActionModules = () => {
  const modules = useAppSelector(
    (state) => state.serviceModules.leaderboardActionModules
  );
  return useMemo(() => {
    if (!Array.isArray(modules)) return [];
    return modules.map(({ id, name }) => ({ id, name }));
  }, [modules]);
};

export const useLeaderboardData = () =>
  useAppSelector((state) => state.serviceModules.leaderboardData);

export const useLeaderboardDashboardData = () =>
  useAppSelector((state) => state.serviceModules.leaderboardDashboardData);

export const useTimeTrackingModuleById = (serviceModuleId: number) =>
  useAppSelector((state) => state.serviceModules.timeTrackingModules[serviceModuleId]);
